<template>
  <div class="bk bk-translations-banner">
    <Icon name="translate" />
    <p v-html="text" />
    <button class="bk-translations-banner-close" @click="onClick">
      {{ $t("translationsBannerButton", "Edit source language instead") }}
      <Icon name="close" />
    </button>
  </div>
</template>

<script setup>
import { computed, useBlokkli } from "#imports";
import { Icon } from "#blokkli/components";
const props = defineProps({
  activeLanguage: { type: Object, required: true }
});
const { $t, adapter, state } = useBlokkli();
const onClick = () => {
  const sourceLanguage = state.translation.value.sourceLanguage;
  if (!sourceLanguage) {
    throw new Error(
      'Missing property "sourceLanguage" in TranslationState object.'
    );
  }
  const sourceTranslation = state.translation.value.translations?.find(
    (v) => v.id === sourceLanguage
  );
  if (!sourceTranslation) {
    throw new Error(
      `Failed to find translation for language "${sourceLanguage}".`
    );
  }
  adapter.changeLanguage(sourceTranslation);
};
const text = computed(() => {
  return $t(
    "translationsBannerText",
    "You are currently editing the <strong>@language</strong> translation. Some features like adding, moving or deleting blocks are not available."
  ).replace("@language", props.activeLanguage.name);
});
</script>
